import { Injectable } from '@angular/core';
import { LoggerService } from './logger.service';
import { StorageService } from '../auth/storage.service';
import { BehaviorSubject } from 'rxjs';
import { tileComponentPool, tilesCollection } from '../tracker/trackerUtils';
import { IProject } from '../models/models.lib';
import { ITrackerStates, TileItem, TrackerStates } from '../common/obj.lib';

const TRACKER_STATES = 'trackerstates';

@Injectable({
  providedIn: 'root'
})
export class AppStateService {

  private _trackerStats: BehaviorSubject<TrackerStates | undefined> = new BehaviorSubject<TrackerStates | undefined>(undefined);
  get trackerStates() {
    return this._trackerStats.getValue();
  }
  set trackerStates(val: TrackerStates | undefined) {
    this._trackerStats.next(val);
  }

  private _defaultTrackerStats: BehaviorSubject<TrackerStates | undefined> = new BehaviorSubject<TrackerStates | undefined>(undefined);
  get defaultTrackerStates() {
    return this._defaultTrackerStats.getValue();
  }
  set defaultTrackerStates(val: TrackerStates | undefined) {
    this._defaultTrackerStats.next(val);
  }

  constructor(
    private logger: LoggerService,
    private storage: StorageService
  ) {
    this.getStates();
  }

  get currentProject(): IProject | undefined {
    return this.trackerStates?.currentProject;
  }

  set currentProject(val: IProject | undefined) {
    let tmp = this.getStates();
    tmp.currentProject = val;
    this.saveStates(tmp);
    // this.settings = tmp;
  }

  get hasTiles(): boolean {
    let tmp = this.getStates();
    if (tmp)
      return tmp.selectedTiles.length > 0;
    else
      return false;
  }

  get currentTiles(): TileItem[] {
    if (this.trackerStates) {
      // this.logger.debug(`get currentTiles: `, this.trackerStates.selectedTiles);
      return this.trackerStates.selectedTiles;
    } else {
      return [];
    }
  }
  set currentTiles(val: TileItem[]) {
    let tmp = this.getStates();
    // this.logger.debug(`set currentTiles: val: `, val);
    // this.logger.debug(`set currentTiles: tmp`, JSON.stringify(tmp));
    if (val) {
      tmp.selectedTiles = val;
    } else {
      tmp.selectedTiles = [];
    }
    this.saveStates(tmp);
  }

  setTheAppStates(overrideCurrent: boolean = false): void {
    // this.logger.debug(`setTheAppStates:`, overrideCurrent);
    if (!overrideCurrent && this.storage.exists(TRACKER_STATES)) {
      // this.logger.debug(`setTheAppStates:storage exists...`);
      this.trackerStates = this.getStates(); // this.storage.getJson(TRACKER_STATES);
    } else {
      // this.logger.debug(`setTheAppStates:defaultTrackerStates`, this.defaultTrackerStates);
      if (this.defaultTrackerStates) {
        // this.logger.debug(`setTheAppStates:using defaults...`);
        this.trackerStates = this.defaultTrackerStates; // TrackerStates.initialise(tilesCollection);
        this.storage.setJson(TRACKER_STATES, this.trackerStates);
      }
    }
    // this.logger.debug(`setTheAppStates: `, JSON.stringify(this.trackerStates));
  }

  saveStates(states: TrackerStates) {
    this.trackerStates = states;
    this.storage.setJson(TRACKER_STATES, this.trackerStates);
  }
  getStates(): TrackerStates {
    let fromStorage = <ITrackerStates>this.storage.getJson(TRACKER_STATES);
    if (fromStorage) {
      let returning = TrackerStates.reCreate(fromStorage, tileComponentPool);
      // this.logger.debug('getStates: ', returning);
      return returning;

    } else {
      return TrackerStates.initialise()
    }
    //  let tmp = this.storage.getJson(TRACKER_STATES);
    //   this.logger.debug(`getStates: `, JSON.stringify(tmp));
    //   if (tmp) {
    //     return tmp;
    //   } else {
    //     this.saveStates(TrackerStates.initialise());
    //   }
  }

  setDefaults() {
    // this.logger.debug(`setDefaults...`);
    this.defaultTrackerStates = TrackerStates.initialise(tilesCollection);
    // this.logger.debug(`setDefaults:defaultTrackerStates: `, JSON.stringify(this.defaultTrackerStates));
  }

  initialize() {
    this.setDefaults();
    this.setTheAppStates();
  }
}
